const reactQueryConfig = {
    queries: {
        staleTime: 5 * 60 * 1000,
    }
};

export default reactQueryConfig;
